// @react/hooks/useUserprofile.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { userprofileStore } from '@core/stores';

/**
 * React hook for Userprofile operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useUserprofile } from '@react/hooks';
 *
 * const UserprofileList = observer(() => {
 *   const store = useUserprofile();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useUserprofile() {
  return userprofileStore;
}
